import srraf from 'srraf'


document.addEventListener('DOMContentLoaded', function() {
	const header = document.querySelector("site-header")
	const drawer = document.querySelector("site-drawer")
	const main = document.querySelector("main")

	const headerListener = srraf(({ x, px, y, py, vh, pvh, vw, pvw }, timestamp) => {
		const offset = header.getBoundingClientRect().height
		drawer.style.top = header.getBoundingClientRect().height + "px"

		if (vw >= 1080) {
			main.style.paddingTop = 0;
		} else {
			main.style.paddingTop = header.getBoundingClientRect().height + "px"
		}
	})

	headerListener.update() // check position
});

class DrawerToggle extends HTMLElement {
  icon = `<svg xmlns="http://www.w3.org/2000/svg" fill=currentColor aria-label="search" width=32 height=32 viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7a32 32 0 0 1-45.3 45.3L330.7 376A208 208 0 1 1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>`

  constructor() {
    super();
  }

  connectedCallback() {
    const button = document.createElement('button')
    button.setAttribute('id', 'open-search-drawer')

    button.addEventListener('click', (e) => this.handlEvent())

    this.append(button)
    button.innerHTML = this.icon
  }

  handlEvent() {
    const input = this.querySelector('input')
    input.checked = true
    const search = document.querySelector('input.js-finder-search-query')
    search.focus()
  }
}

customElements.define('drawer-toggle', DrawerToggle)

window.addEventListener('DOMContentLoaded', () => {
	new Swiper(".swiper", {
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '"></span>';
			},
		},
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
	});
});

document.addEventListener('DOMContentLoaded', function(){
	const persons = document.querySelectorAll('li:has(> .person-bio)')

	for (const person of persons) {
		person.addEventListener('click', function(){
			const details = this.querySelector('details')

			details.toggleAttribute('open')
		})
	}
}, false);


// 404 page handling
window.addEventListener('DOMContentLoaded', async() => {
	const container = document.querySelectorAll('.page-404')[0]
	if (!container) return

	const redirectPlaceholder = container.querySelector('#redirect-placeholder')
	if (!redirectPlaceholder) return

	const currentURL = new URL(window.location.href)
	const error404 = [...currentURL.searchParams].find(([key, value]) => key === '404')?.[1]
	const errorExists = [...currentURL.searchParams].find(([key, value]) => key === 'exists' && value === '1')?.[1] === '1'
	if (!error404) return
	if (!errorExists) return

	const redirectLink = redirectPlaceholder.querySelector('a')
	redirectLink.href =  `https://archive.britishcolumbiagolf.org${error404}`
	redirectPlaceholder.classList.remove('hidden')

	// update search field to have the page url in it
	const search = container.querySelector('input[name=q]')
	if (!search) return

	let value = error404.split('/')
	value = value[value.length - 1]
	value = value.replaceAll('-', ' ')

	search.value = value
})
